import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import DocumentationItem from 'components/UI/Documentation/DocumentationItem';


const useStyles = makeStyles((theme) => ({
  root: {
  },
}));


export default function DocumentationList(props) {

  const { rows } = props;
  
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Grid container align="flex-start">
        {rows.map((row, i)=>
          <Grid key={row.id} item xs={12} sm={6} md={4}>
            <DocumentationItem data={row}/>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};



// WEBPACK FOOTER //
// ./src/components/UI/Documentation/DocumentationList.jsx